var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutbox"},[(_vm.result.length > 0)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.result[0].value))]),_c('div',[_vm._v(_vm._s(_vm.result[1].value))])]):_vm._e(),_c('img',{attrs:{"src":"https://img.hozoin.cn/news_img/2021089/16284731160001568.png","alt":"孔"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }